import React from "react";
import OperatorRequestDetails from "./OperatorRequestDetails";

const CustomsRebateDetails = () => <OperatorRequestDetails />;

export default CustomsRebateDetails;
